import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { schedule as scheduleAppointment } from "../requests/appointment";
import { createSignal } from "solid-js";

export default function useAppointmentSchedule(props) {

  const [showModal, setShowModal] = createSignal(false);
  const [title, setTitle] = createSignal("Schedule Appointment");
  const [type, setType] = createSignal("schedule");

  const [loading, setLoading] = createSignal(false);

  const [scheduleForm, setScheduleForm] = createStore({
    appointmentId: null,
    date: new Date().toISOString().split('T')[0],
  });

  const { successToast, errorToast } = useApplication();

  const showRescheduleAppointmentModal = () => {
    setTitle("Reschedule Appointment");
    setType("reschedule");
    setShowModal(true);
  }

  const showNextAppointmentModal = () => {
    setTitle("Schedule Next Appointment");
    setType("next");
    setShowModal(true);
  }

  const closeModal = () => {
    setShowModal(false);
  }

  const onSaveSchedule = async () => {
    if (!scheduleForm.date) {
      errorToast("Please select a date for the appointment");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('appointmentId', props.key);
      formData.append('date', scheduleForm.date);
      formData.append('type', type());

      const data = await scheduleAppointment(formData);

      if (data.success) {
        successToast(data.message || "Appointment scheduled successfully");
        closeModal();
        setScheduleForm('date', new Date().toISOString().split('T')[0]);
      } else {
        errorToast(data.message || "Failed to schedule appointment");
      }
    } catch(error) {
      errorToast("Failed to schedule appointment");
    } finally {
      setLoading(false);
    }
  };

  const handleScheduleInput = (name, value) => {
    setScheduleForm([name], value);
  };

  return {
    showRescheduleAppointmentModal,
    showNextAppointmentModal,
    closeModal,
    showModal,
    title,
    handleScheduleInput,
    onSaveSchedule,
    loading,
    scheduleForm,
  }
}
